import axios from '@/api/requests/axios'

export default {
  getAll: (params) => axios.get(`/api/admin/v1/orders`, { params }),
  getById: (id) => axios.get(`/api/admin/v1/orders/${id}`),
  getLogs: (id) => axios.get(`/api/admin/v1/orders/logs/${id}`),
  getWorkflowData: (id) => axios.get(`/api/admin/v1/orders/workflow-data/${id}`),
  suspendWorkflow: (id) => axios.post(`/api/admin/v1/orders/suspend-workflow/${id}`),
}
